import React from "react";

const ProplusdataApproach = () => {
  return (
    <div className="subscribe_area pt-10">
     
       <div className="col-lg-12 case-study-details">
           
                <div class="case-study-details-full-title mt-5 ml-40 ">
                  <h3>The ProPlus GTM Approach</h3>
                </div>
              
             
            <img
              src="assets/images/aws-flow.png" 
              alt="proplus data approach" 
              className="mx-auto w-32"
            /> 
         
         
        </div>
    </div>
  );
};

export default ProplusdataApproach;
